/**
 * 增加用户密码
 */
function addPassword() {
    var add_password = $('#add_password').val();//密码
    var add_confirm_password = $('#add_confirm_password').val();//确认密码
    var add_Vcode = $('#add_Vcode').val();//验证码
    if (add_password == null || add_password.length <= 0) {
        layer.msg("请输入输入密码！");
        return;
    }
    if (add_confirm_password == null || add_confirm_password.length <= 0) {
        layer.msg("请输入确认密码！");
        return;
    }
    if (add_Vcode == null || add_Vcode.length <= 0) {
        layer.msg("请输入验证码！");
        return;
    }
    if (add_password != add_confirm_password) {
        layer.msg("两次密码输入不一致，请重新输入！");
        return;
    }
    $('#btnAddPassword').attr("disabled", true);

    updatevisitdetaildata('users.py', 'addPassword')
    let verCode = add_Vcode;
    let password = add_password;

    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let phone = authdata.data.userPhone
    let token = localStorage.getItem("token")
    let data = {
        'password': password,
        'phone': phone,
        'code': verCode
    };
    $.ajax({
        url: serverUrl + "/addPassword",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {

            if (data.code == 200) {
                layer.msg("添加密码成功", { time: 1000 }, function () {
                    location.reload();
                });
            }
            else {
                $('#btnAddPassword').attr("disabled", false);
                layer.msg(data.msg);
            }
        }

    });
}
/**
 * 修改密码
 */
export const changePassword = () => {
    var old_password = $('#old_password').val();//旧密码
    var update_password = $('#update_password').val();//新密码
    var update_confirm_password = $('#update_confirm_password').val();//确认新密码
    var add_Vcode = $('#update_Vcode').val();//验证码
    if (old_password == null || old_password.length <= 0) {
        layer.msg("请输入输入旧密码！");
        return;
    }
    if (update_password == null || update_password.length <= 0) {
        layer.msg("请输入输入新密码！");
        return;
    }
    if (update_confirm_password == null || update_confirm_password.length <= 0) {
        layer.msg("请输入确认新密码！");
        return;
    }
    if (add_Vcode == null || add_Vcode.length <= 0) {
        layer.msg("请输入验证码！");
        return;
    }
    if (update_password != update_confirm_password) {
        layer.msg("两次新密码输入不一致，请重新输入！");
        return;
    }
    $('#btnUpdatePassword').attr("disabled", true);
    updatevisitdetaildata('users.py', 'chanagepassword')
    let verCode = add_Vcode;
    let oldPassword = old_password;
    let newPassword = update_password;

    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let token = localStorage.getItem("token")
    let phone = authdata.data.userPhone
    let data = {
        'newPassword': newPassword,
        'phone': phone,
        'oldpassword': oldPassword,
        'code': verCode
    };
    $.ajax({
        url: serverUrl + "/changePassword",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {

            if (data.code == 200) {
                layer.msg("修改密码成功", { time: 1000 }, function () {
                    location.reload();
                });
            }
            else {
                $('#btnUpdatePassword').attr("disabled", false);
                layer.msg(data.msg);
            }
        }

    });
}
/**
 * 修改手机号
 */
function changePhone() {
    var phone = $('#newPhone').val();//手机号
    var phone_Vcode = $('#phone_Vcode').val();//验证码
    if (phone == null || phone.length <= 0) {
        layer.msg("请输入输入手机号！");
        return;
    }
    if (phone_Vcode == null || phone_Vcode.length <= 0) {
        layer.msg("请输入验证码！");
        return;
    }

    $('#btnChangePhone').attr("disabled", true);
    let verCode = phone_Vcode;
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let userId = authdata.data.userId
    let token = localStorage.getItem("token")
    let data = {
        'userId': userId,
        'phone': phone,
        'code': verCode
    };
    $.ajax({
        url: serverUrl + "/changePhone",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {

            if (data.code == 200) {
                layer.msg("修改手机号成功,请重新登录！", { time: 1000 }, function () {
                    location.reload();
                });
            }
            else {
                $('#btnChangePhone').attr("disabled", false);
                layer.msg(data.msg);
            }
        }

    });
}
/**
 * 上传身份证
 */
function uploadCard() {
    var card_zhengmian_address = $('#sfz_zhengmian_address').val();//身份证正面地址
    var card_fanmian_address = $('#sfz_beimian_address').val();//身份证反面地址
    if (card_zhengmian_address == null || card_zhengmian_address.length <= 0) {
        layer.msg("上传身份证正面照片！");
        return;
    }
    if (card_fanmian_address == null || card_fanmian_address.length <= 0) {
        layer.msg("上传身份证反面照片！");
        return;
    }
    $('#btnUploadCard').attr("disabled", true);
    updatevisitdetaildata('users.py', 'uploadCard')
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    authdata = JSON.parse(authdata)
    let userId = authdata.data.userId
    let token = localStorage.getItem("token")
    let data = {
        'userId': userId,
        'card_zhengmian_address': card_zhengmian_address,
        'card_fanmian_address': card_fanmian_address
    };
    $.ajax({
        url: serverUrl + "/uploadCard",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {

            if (data.code == 200) {
                layer.msg("身份认证成功！", { time: 1000 }, function () {
                    location.reload();
                });
            }
            else {
                $('#btnUploadCard').attr("disabled", false);
                layer.msg(data.msg);
            }
        }

    });
}
/**
 * 保存基本数据
 */
let that;
export const saveBasicData = (aa) => {
    that = aa;
    var identityType = $('#identityType').val();
    if (identityType.length <= 0) {
        layer.msg('用户信息错误，不能保存！');
        return;
    }
    var userId = $('#userId').val();
    var avatar = $('#avatar_url').val();
    var input_sign = $('#input_sign').val();
    var nickName = $('#nickName').val();
    var birthDate = $('#birthDate').val();
    var usertype = $('#inputEmail3').val();
    var companyTradeType = $('#b_divgrading').val();
    if (nickName.length <= 0) {
        layer.msg('请输入昵称！');
        return;
    }
    var userPost = '';
    var addressDetail = '';
    var userEmail = '';
    var companyName = '';
    var address_code = '';
    var address_name = '';
    var companyTradeName = '';
    var cityLifeCode = "";
    var cityLifeName = "";

    if (!$("#div_addressCity").children(".city-picker-span").children(".title").children(".select-item").html()) {
        cityLifeCode = that.authdata.data.cityLifeCode;
        cityLifeName = that.authdata.data.cityLifeName;
    }
    $("#div_addressCity").children(".city-picker-span").children(".title").children(".select-item").each(function () {//todo 区域不可编辑
        if (cityLifeCode.length <= 0) {
            cityLifeCode = $(this).attr('data-code');
            cityLifeName = $(this).html();
        }
        else {
            cityLifeCode = cityLifeCode + ',' + $(this).attr('data-code');
            cityLifeName = cityLifeName + ',' + $(this).html();
        }
    });//todo 区域不可编辑

    userPost = $('#userPost').val();
    addressDetail = $('#addressDetail').val();
    userEmail = $('#userEmail').val();
    if (userEmail.length <= 0) {
        layer.msg('请输入邮箱！');
        return;
    }
    if (userPost.length <= 0) {
        layer.msg('所属职位！');
        return;
    }

    // if(addressDetail.length <=0) {
    //     layer.msg('请输入详细地址，名片需要！');
    //     return;
    // }

    companyName = $('#companyName').val();
    if (companyName.length <= 0) {
        layer.msg('所属公司！');
        return;
    }

    // 半年只能修改一次
    if (!that.editFlg) {

        if (!$("#div_address").children(".city-picker-span").children(".title").children(".select-item").html()) {
            address_code = that.authdata.data.companyAreaIds;
            address_name = that.authdata.data.companyAreaNames;
        }
        $("#div_address").children(".city-picker-span").children(".title").children(".select-item").each(function () {//todo 区域不可编辑
            if (address_code.length <= 0) {
                address_code = $(this).attr('data-code');
                address_name = $(this).html();
            } else {
                address_code = address_code + ',' + $(this).attr('data-code');
                address_name = address_name + ',' + $(this).html();
            }
        });

        if (address_code.length <= 0) {
            layer.msg('请选择公司所在区域！');
            return;
        }
    }

    updatevisitdetaildata('users.py', 'savebasicdata')
    let companyAreaIds = address_code;
    let companyAreaNames = address_name;
    let mySign = input_sign;
    let authdata = localStorage.getItem("authdata")
    if (authdata == null) {
        layer.alert('用户未登陆!', { icon: 6 });
        return;
    }
    let token = localStorage.getItem("token")
    let data = {
        'userId': userId,
        'nickName': nickName,
        'birthDate': birthDate,
        'cityLifeCode': cityLifeCode,
        'cityLifeName': cityLifeName,
        'userEmail': userEmail,
        'userPost': userPost,
        'addressDetail': addressDetail,
        'companyName': companyName,
        'companyAreaIds': companyAreaIds,
        'companyAreaNames': companyAreaNames,
        'avatar': avatar,
        'mySign': mySign,
        'companyTradeType': companyTradeType,
        "companyTradeName": companyTradeName,
        "editFlg": that.editFlg
    };
    $.ajax({
        url: serverUrl + "/savebasicdata",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            "Authorization": "Api_Bearer " + token,
            'Content-Type': 'application/json'
        },
        success: function (data) {
            if (data.code == 200) {
                layer.msg("保存成功");
                let username = localStorage.getItem("username")
                let token = localStorage.getItem("token")
                if (username != null && token != null) {
                    this.showLogin = true
                    localStorage.setItem("showLogin", 1)
                    let header = {}
                    $.ajax({
                        url: serverUrl + "/userinfo",
                        type: "get",
                        async: true,
                        headers: (header = {
                            username: username,
                            Authorization: "Api_Bearer " + token,
                            //'connection':'keep-alive',
                            "Content-Type": "application/json",
                        }),
                        success: function (data) {
                            if (data.code == 200) {
                                localStorage.setItem("authdata", JSON.stringify(data))
                                that.$router.push({
                                    name: "personalIndex",
                                    query: {
                                        id: userId,
                                    },
                                })
                            }
                        }

                    })
                }
            }
            else {
                layer.msg(data.msg);
            }
        }

    });
}
/**
 * 忘记密码
 */
export function forGetPassword(phone, password, verCode) {
    let data = {
        'password': password,
        'phone': phone,
        'code': verCode
    };
    $.ajax({
        url: serverUrl + "/forgetPassword",
        type: "post",
        async: true,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
        headers: {
            'Content-Type': 'application/json'
        },
        success: function (data) {
            if (data.code == 200) {
                layer.msg("重置密码成功！", { time: 1000 }, function () {
                    location.reload();
                });
            }
            else {
                layer.msg(data.msg);
            }
        }

    });
}